import React from 'react';
import { PromptVariable, PromptVariableStringValue, PromptVariableViewModel } from '../../types';
import { VariableValueItem } from './VariableValueItem';
import { PlusSmallIcon } from '../../../assets/icons';
import { DivButton } from '../../../commons/components/DivButton';

export const VariableOfListTypeItems = ({
  variable,
  onUpdate,
}: {
  variable: PromptVariableViewModel;
  onUpdate: (newValue: PromptVariable) => void;
}) => {
  const onAddNewClick = async () => {
    if (variable.variableValue.type === 'list') {
      const updateValue: PromptVariable = {
        ...variable,
        variableValue: {
          ...variable.variableValue,
          values: [
            ...variable.variableValue.values,
            { type: 'string', value: '', description: '', name: '' },
          ],
        },
      };
      await onUpdate(updateValue);
    }
  };

  if (variable.variableValue.type === 'list') {
    return (
      <>
        {variable.variableValue.values.map((value, idx) => (
          <VariableValueItem
            key={`variable-value-${value.value}-${value.description}-${idx}`}
            idxOfList={idx}
            variableName={variable.variableValue.name}
            origValue={value}
            onUpdate={async (newValue: PromptVariableStringValue) => {
              if (variable.variableValue.type === 'list') {
                const updateValue: PromptVariable = {
                  ...variable,
                  variableValue: {
                    ...variable.variableValue,
                    values: variable.variableValue.values.map((x, i) => (i === idx ? newValue : x)),
                  },
                };
                await onUpdate(updateValue);
              }
            }}
            onDelete={async () => {
              if (variable.variableValue.type === 'list') {
                const updateValue: PromptVariable = {
                  ...variable,
                  variableValue: {
                    ...variable.variableValue,
                    values: variable.variableValue.values.filter((x, i) => i !== idx),
                  },
                };
                await onUpdate(updateValue);
              }
            }}
          />
        ))}
        <div className="variables-table__row d-flex">
          <DivButton
            isGray={true}
            icon={<PlusSmallIcon />}
            text={`Add new ${variable.nameLabel?.toLowerCase() || variable.variableValue.name}`}
            onClick={async () => onAddNewClick()}
            className="common-table__add-new-btn"
            dataTest="variables-table__add-new-btn"
          />
        </div>
      </>
    );
  }

  return null;
};
